import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentBOL from 'app/models/fulfillment_bol';
import FulfillmentWarehouses from 'app/collections/fulfillment_warehouses';

export default Base.extend({
  model: FulfillmentBOL,
  key: 'bols',
  url: fulfillmentUrl('bols', 'v2'),

  initialize(models, { dateRange, apiModeSelection }) {
    this.dateRange = dateRange;
    this.apiModeSelection = apiModeSelection;
    this.warehouses = new FulfillmentWarehouses({});
    this.listenTo(this.dateRange, 'change', this.reportFiltered);
    this.listenTo(this.apiModeSelection, 'change', this.reportFiltered);
  },

  reportFiltered() {
    this.trigger('filtered');
  },

  comparator(model) {
    return -model.get('created_at');
  },

  searchById(term) {
    if (!term || !term.trim()) {
      this.reset();
      this.trigger('sync');
      return;
    }

    // call fulfillment api, based on prefix to get by either warehouse id or
    const filterType = term.trim().split('_', 1)[0];
    const self = this;

    if (filterType === 'bol') {
      new this.model({ id: term }).fetch({
        data: { ...this.apiModeSelection.getParams(), includes: ['warehouse', 'line_items'] },
        success(model) {
          self.reset([model]);
        },
        error() {
          self.reset();
          self.trigger('sync');
        },
      });

      return;
    }

    // assume tracking code
    this.fetch({ data: { query: term } });
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      ...this.dateRange.getParams(),
      includes: ['warehouse', 'line_items'],
    };
  },

  parse(response) {
    this.hasMore = response[this.key].length === 10;
    this.warehouses.reset(response.warehouses);
    return response[this.key];
  },
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_bols.js